import React, { useState } from "react";
import { gotoSearchPage, areEqualObjValue } from "./Common";
import {
  SelectList,
  IonRange,
  RangeInput,
  CounterInput,
  CheckBoxIonInput,
  CheckBoxCustomInput,
} from "./Component";

import Config from "config";

const priceFilter = Config.priceFilter;
const provinceFilter = Config.provinceFilter;
const propertyTypeFilter = Config.propertyTypeFilter;

// axios.defaults.headers.common['Authorization'] = store.getState().Token;
//process.env.API_ROOT_URL

export const DeskTopSearch = React.memo((props) => {
  const searchFilter = props;
  const searchDataChange = props.searchDataChange;
  const IonRangeDataChange = props.IonRangeDataChange;
  const RangeInputDataChange = props.RangeInputDataChange;
  const OnRadioCheck = props.OnRadioCheck;
  const GoToSearch = props.GoToSearch;
  const ClearSearch = props.ClearSearch;
  const OnInputChange = props.OnInputChange;
  const hideDesktop = props.hideDesktop;

  const renderAssetTypesCheckBox = (item, index) => {
    if (item[0] !== "fieldName" && item[0] !== "value") {
      const fieldName = item[0];
      const data = item[1];
      // console.log('item', fieldName, data,item[1]);
      // console.log("asset-type-m" + index)
      return (
        <div className="checkbox-card" key={"asset-type-desk" + index}>
          <CheckBoxCustomInput {...data} OnformsDataChange={OnRadioCheck} />
        </div>
      );
    }
  };

  // console.log("Desktop Search render")

  return (
    <div id="search-wrapper" className={hideDesktop ? "search-section d-none" : "search-section"}>
      <div id="searchx" className="main-search">
        <h2>ทรัพย์มือสองทำเลดี ทั่วไทย</h2>
        <div className="search-bar">
          <div className="input-group">
            <input
              id="property-search"
              type="text"
              placeholder="ชื่อโครงการ/รหัสทรัพย์/อื่นๆ"
              name="property"
              value={searchFilter.keyword.value}
              onChange={(e) => OnInputChange("keyword", e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && GoToSearch()}
            />
            <div className="search-btn" onClick={GoToSearch}>
              <i className="ic-npa ic-npa-icon-search"></i>
            </div>
          </div>
          <div className="more-filter-wrap">
            <a
              href="#"
              className="more-filter-btn mobile"
              data-bs-toggle="offcanvas"
              data-bs-target="#more-filter-mobile"
              aria-controls="more-filter-mobile"
            >
              <i className="ic-npa ic-npa-icon-filter"></i>
            </a>
            <a href="#" className="more-filter-btn desktop">
              <i className="ic-npa ic-npa-icon-filter"></i>
            </a>
            <a href="#" className="more-filter-btn close">
              <img
                src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/close-filter.svg"
                alt="Close filter"
              />
            </a>
          </div>
        </div>
      </div>

      <div id="more-filter-desktop" className="filter-search">
        <div className="search-detail-wrapper">
          <h2 className="mb-3">ค้นหาอย่างละเอียด</h2>
          <div className="desktop-filter-wrap">
            <div className="left">
              <div className="d-flex align-items-center justify-content-between mb-4">
                {/* <div className="checkbox-card">
                                    <CheckBoxCustomInput {...searchFilter.assetTypes.propertybank} OnformsDataChange={OnRadioCheck} />
                                </div>
                                <div className="checkbox-card">
                                    <CheckBoxCustomInput {...searchFilter.assetTypes.propertywaitsale} OnformsDataChange={OnRadioCheck} />
                                </div> */}
                {Object.entries(searchFilter.assetTypes).map((item, index) =>
                  renderAssetTypesCheckBox(item, index)
                )}
              </div>
              <h2 className="my-3">ประเภททรัพย์</h2>
              <div className="d-flex align-items-start justify-content-between mb-2 mx-auto">
                <div className="asset-radio">
                  <CheckBoxIonInput
                    {...searchFilter.propertyType.housetype}
                    OnformsDataChange={OnRadioCheck}
                  />
                </div>
                <div className="asset-radio">
                  <CheckBoxIonInput
                    {...searchFilter.propertyType.land}
                    OnformsDataChange={OnRadioCheck}
                  />
                </div>
                <div className="asset-radio">
                  <CheckBoxIonInput
                    {...searchFilter.propertyType.townhouse}
                    OnformsDataChange={OnRadioCheck}
                  />
                </div>
                <div className="asset-radio">
                  <CheckBoxIonInput
                    {...searchFilter.propertyType.condo}
                    OnformsDataChange={OnRadioCheck}
                  />
                </div>
              </div>

              <div className="d-flex align-items-start justify-content-between mb-2 mx-auto">
                <div className="asset-radio">
                  <CheckBoxIonInput
                    {...searchFilter.propertyType.commercialbuilding}
                    OnformsDataChange={OnRadioCheck}
                  />
                </div>
                <div className="asset-radio">
                  <CheckBoxIonInput
                    {...searchFilter.propertyType.warehouse}
                    OnformsDataChange={OnRadioCheck}
                  />
                </div>
                <div className="asset-radio">
                  <CheckBoxIonInput
                    {...searchFilter.propertyType.factory}
                    OnformsDataChange={OnRadioCheck}
                  />
                </div>
                <div className="asset-radio">
                  <CheckBoxIonInput
                    {...searchFilter.propertyType.apartment}
                    OnformsDataChange={OnRadioCheck}
                  />
                </div>
              </div>

              <div
                className="d-flex align-items-start justify-content-between mb-2 mx-auto"
                style={{ maxWidth: "250px" }}
              >
                <div className="asset-radio">
                  <CheckBoxIonInput
                    {...searchFilter.propertyType.office}
                    OnformsDataChange={OnRadioCheck}
                  />
                </div>
                <div className="asset-radio">
                  <CheckBoxIonInput
                    {...searchFilter.propertyType.resort}
                    OnformsDataChange={OnRadioCheck}
                  />
                </div>
                <div className="asset-radio">
                  <CheckBoxIonInput
                    {...searchFilter.propertyType.houseother}
                    OnformsDataChange={OnRadioCheck}
                  />
                </div>
              </div>
            </div>

            <div className="right">
              <div className="inner-content">
                <h3>ทำเลที่ตั้ง</h3>
                <SelectList
                  id="province"
                  {...searchFilter.province}
                  OnformsDataChange={searchDataChange}
                />
                <div className="row mb-3">
                  <div className="col-6" style={{ paddingRight: "5px" }}>
                    <SelectList
                      id="district"
                      {...searchFilter.district}
                      OnformsDataChange={searchDataChange}
                    />
                  </div>
                  <div className="col-6" style={{ paddingLeft: "5px" }}>
                    <SelectList
                      id="sub-district"
                      {...searchFilter.subDistrict}
                      OnformsDataChange={searchDataChange}
                    />
                  </div>
                </div>
                <h3>ช่วงราคา (บาท)</h3>
                <div className="row mb-3">
                  <div className="col-6" style={{ paddingRight: "5px" }}>
                    <RangeInput
                      {...searchFilter.rangePrice}
                      OnformsDataChange={RangeInputDataChange}
                    />
                  </div>
                  <div className="col-6" style={{ paddingLeft: "5px" }}>
                    <IonRange {...searchFilter.rangePrice} OnformsDataChange={IonRangeDataChange} />
                  </div>
                </div>
                <h3>เนื้อที่ (ตร.ว.)</h3>
                <div className="row mb-3">
                  <div className="col-6" style={{ paddingRight: "5px" }}>
                    <RangeInput
                      {...searchFilter.areaRange}
                      OnformsDataChange={RangeInputDataChange}
                    />
                  </div>
                  <div className="col-6" style={{ paddingLeft: "5px" }}>
                    <IonRange {...searchFilter.areaRange} OnformsDataChange={IonRangeDataChange} />
                  </div>
                </div>
                <h3>พื้นที่ใช้สอย (ตร.ม.)</h3>
                <div className="row mb-3">
                  <div className="col-6" style={{ paddingRight: "5px" }}>
                    <RangeInput
                      {...searchFilter.useableAreaRange}
                      OnformsDataChange={RangeInputDataChange}
                    />
                  </div>
                  <div className="col-6" style={{ paddingLeft: "5px" }}>
                    <IonRange
                      {...searchFilter.useableAreaRange}
                      OnformsDataChange={IonRangeDataChange}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-6 d-flex align-items-center" style={{ paddingRight: "5px" }}>
                    <div className="w-50 h-100" style={{ paddingRight: "3px" }}>
                      <h3>ห้องนอน</h3>
                      <CounterInput
                        {...searchFilter.bedroom}
                        OnformsDataChange={searchDataChange}
                      />
                    </div>
                    <div className="w-50 h-100" style={{ paddingLeft: "3px" }}>
                      <h3>ห้องน้ำ</h3>
                      <CounterInput
                        {...searchFilter.bathroom}
                        OnformsDataChange={searchDataChange}
                      />
                    </div>
                  </div>
                  <div className="col-6" style={{ paddingLeft: "5px" }}>
                    <h3>สถานีใกล้เคียง BTS/MRT</h3>
                    <SelectList
                      id="bts-mrt"
                      {...searchFilter.station}
                      OnformsDataChange={searchDataChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <div className="submit-wrapper p-3 px-md-5 py-md-4">
                <button type="button" className="btn-main btn-first" onClick={GoToSearch}>
                  ค้นหา
                </button>
                <button type="button" name="clear" className="clear-data" onClick={ClearSearch}>
                  <i className="ic-npa ic-npa-icon-clearsearch"></i>
                  ล้างการค้นหา
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}, areEqual);

function areEqual(prevProps, nextProps) {
  return areEqualObjValue(prevProps, nextProps);
}

export const MobileSearch = React.memo((props) => {
  const searchFilter = props;
  const searchDataChange = props.searchDataChange;
  const IonRangeDataChange = props.IonRangeDataChange;
  const RangeInputDataChange = props.RangeInputDataChange;
  const OnRadioCheck = props.OnRadioCheck;
  const GoToSearch = props.GoToSearch;
  const ClearSearch = props.ClearSearch;
  const OnInputChange = props.OnInputChange;

  const renderCheckBox = (item, index) => {
    if (item[0] !== "fieldName" && item[0] !== "value") {
      const fieldName = item[0];
      const data = item[1];
      // console.log('item', fieldName, data,item[1]);
      // console.log("property-type-m" + index)
      return (
        <div className="swiper-slide" key={"property-type-m" + index}>
          <div className="asset-radio">
            <CheckBoxIonInput {...data} OnformsDataChange={OnRadioCheck} />
          </div>
        </div>
      );
    }
  };

  const renderAssetTypesCheckBox = (item, index) => {
    if (item[0] !== "fieldName" && item[0] !== "value") {
      const fieldName = item[0];
      const data = item[1];
      // console.log('item', fieldName, data,item[1]);
      // console.log("asset-type-m" + index)
      return (
        <div className="checkbox-card" key={"asset-type-m" + index}>
          <CheckBoxCustomInput {...data} OnformsDataChange={OnRadioCheck} />
        </div>
      );
    }
  };

  // console.log("mobileSearch render")

  return (
    <div id="more-filter-mobile" className="offcanvas offcanvas-bottom">
      <div className="offcanvas-header position-relative d-flex justify-content-center align-items-center">
        <h2 className="offcanvas-title" id="offcanvasBottomLabel">
          ค้นหาอย่างละเอียด
        </h2>
        <button
          type="button"
          className="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body px-0">
        <div id="more-filter-m-form" className="more-filter-m-form">
          <div className="px-3 px-md-5 mb-3">
            <input
              id="asset-code"
              type="text"
              className="normal-input"
              placeholder="ชื่อโครงการ/รหัสทรัพย์/อื่นๆ"
              value={searchFilter.keyword.value}
              onChange={(e) => OnInputChange("keyword", e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && GoToSearch()}
            />
          </div>
          <div className="d-flex align-items-center justify-content-between px-3 px-md-5 mb-3">
            {Object.entries(searchFilter.assetTypes).map((item, index) =>
              renderAssetTypesCheckBox(item, index)
            )}
          </div>
          <div className="p-3 px-md-5">
            <h3>ทำเลที่ตั้ง</h3>
            <SelectList
              id="province-m"
              {...searchFilter.province}
              OnformsDataChange={searchDataChange}
            />
            <SelectList
              id="district-m"
              {...searchFilter.district}
              OnformsDataChange={searchDataChange}
            />
            <SelectList
              id="sub-district-m"
              {...searchFilter.subDistrict}
              OnformsDataChange={searchDataChange}
            />
          </div>
          <div className="p-3 px-md-5">
            <h3 className="mb-4">ประเภททรัพย์</h3>
            <div className="property-type-swiper">
              <div className="d-flex flex-wrap justify-content-center">
                {Object.entries(searchFilter.propertyType).map((item, index) =>
                  renderCheckBox(item, index)
                )}
              </div>
              <div className="swiper-pagination property-type-pagi scroll-pagi"></div>
            </div>
          </div>
          <div className="p-3 px-md-5">
            <h3 className="mb-4">ช่วงราคา (บาท)</h3>
            <RangeInput {...searchFilter.rangePrice} OnformsDataChange={RangeInputDataChange} />
            <IonRange {...searchFilter.rangePrice} OnformsDataChange={IonRangeDataChange} />
          </div>
          <div className="p-3 px-md-5">
            <h3 className="mb-4">เนื้อที่ (ตร.ว.)</h3>
            <RangeInput {...searchFilter.areaRange} OnformsDataChange={RangeInputDataChange} />
            <IonRange {...searchFilter.areaRange} OnformsDataChange={IonRangeDataChange} />
          </div>
          <div className="p-3 px-md-5">
            <h3 className="mb-4">พื้นที่ใช้สอย (ตร.ม.)</h3>
            <RangeInput
              {...searchFilter.useableAreaRange}
              OnformsDataChange={RangeInputDataChange}
            />
            <IonRange {...searchFilter.useableAreaRange} OnformsDataChange={IonRangeDataChange} />
          </div>
          <div className="d-flex align-items-center justify-content-between p-3 px-md-5">
            <div className="w-50" style={{ paddingRight: "20px" }}>
              <h3>ห้องนอน</h3>
              <CounterInput {...searchFilter.bedroom} OnformsDataChange={searchDataChange} />
            </div>
            <div className="w-50" style={{ paddingLeft: "20px" }}>
              <h3>ห้องน้ำ</h3>
              <CounterInput {...searchFilter.bathroom} OnformsDataChange={searchDataChange} />
            </div>
          </div>
          <div className="p-3 px-md-5">
            <h3>สถานีใกล้เคียง BTS/MRT</h3>
            <SelectList
              id="bts-mrt-m"
              {...searchFilter.station}
              OnformsDataChange={searchDataChange}
            />
          </div>
          <div className="submit-wrapper p-3 px-md-5 py-md-4">
            <button type="button" className="btn-main btn-first" onClick={GoToSearch}>
              ค้นหา
            </button>
            <button type="button" name="clear" className="clear-data" onClick={ClearSearch}>
              <img
                src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/clear-data.svg"
                alt="ล้างการค้นหา"
              />
              ล้างการค้นหา
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}, areEqual);

export const TabSearch = (props) => {
  const hideDesktop = props.hideDesktop;

  const priceTab = (priceFilter) => {
    priceFilter = priceFilter.map((x, index) => {
      const M = 1000000;
      const begin = x.start ? 0 : x.price * M;
      const end = x.start ? x.price * M : x.end ? 0 : x.price2 * M;
      const range = begin + (end === 0 ? "" : "," + end);

      return (
        <div className="swiper-slide" key={`range-${range}`}>
          <a href={gotoSearchPage({ rangePrice: range })}>
            <div className="sm-thumbnail-slide">
              <div className="sm-thumbnail-inner custom">
                <p className="title">
                  {x.title}
                  <span>
                    {x.price}
                    {x.price2 && ` - ${x.price2}`}
                  </span>
                </p>
                <p className="unit">ล้านบาท</p>
              </div>
            </div>
          </a>
        </div>
      );
    });

    return priceFilter;
  };

  const provinceTab = (provinceFilter) => {
    provinceFilter = provinceFilter.map((x, index) => {
      return (
        <div className="swiper-slide" key={`provinceCode-${x.provinceCode}`}>
          <a href={gotoSearchPage({ province: x.provinceCode })}>
            <div className="sm-thumbnail-slide">
              <div className={`sm-thumbnail-inner travel ${x.class}`}>
                <p className="travel-title">{x.provinceName}</p>
              </div>
            </div>
          </a>
        </div>
      );
    });

    return provinceFilter;
  };

  const propertyTypeTab = (propertyTypeFilter) => {
    propertyTypeFilter = propertyTypeFilter.map((x, index) => {
      if (x.propertyTypeCode != "19") {
        return (
          <div className="swiper-slide custom-width" key={`propertyTypeCode-${x.propertyTypeCode}`}>
            <a href={gotoSearchPage({ propertyType: x.propertyTypeCode })}>
              <div className="sm-thumbnail-slide">
                <div className="sm-thumbnail-inner">
                  <i className={`ic-npa ${x.class}`}></i>
                  <p dangerouslySetInnerHTML={{ __html: x.propertyTypeName }}></p>
                </div>
              </div>
            </a>
          </div>
        );
      }
    });

    return propertyTypeFilter;
  };

  return (
    <div
      id="property-tab-search"
      className={hideDesktop ? "property-tabs-sec d-none" : "property-tabs-sec"}
    >
      <div className="property-nav-wrap">
        <ul className="nav property-nav" role="tablist">
          <li className="nav-item" role="tab">
            <a
              href="#"
              className="nav-link active"
              data-bs-target="#assets-type-tabs"
              data-bs-toggle="pill"
              aria-selected="true"
            >
              <i className="ic-npa ic-npa-icon-house"></i>
              <span>ประเภททรัพย์</span>
            </a>
          </li>
          <li className="nav-item" role="tab">
            <a
              href="#"
              className="nav-link"
              data-bs-target="#assets-type-tabs2"
              data-bs-toggle="pill"
              aria-selected="false"
            >
              <i className="ic-npa ic-npa-icon-populararea"></i>
              <span>พื้นที่ยอดนิยม</span>
            </a>
          </li>
          <li className="nav-item" role="tab">
            <a
              href="#"
              className="nav-link"
              data-bs-target="#assets-type-tabs3"
              data-bs-toggle="pill"
              aria-selected="false"
            >
              <i className="ic-npa ic-npa-icon-pricerange"></i>
              <span>ช่วงราคา</span>
            </a>
          </li>
        </ul>
      </div>
      <div className="tab-content">
        <div id="assets-type-tabs" className="tab-pane fade show active" role="tabpanel">
          <div className="swiper k-property-swiper-1">
            <div className="swiper-wrapper">{propertyTypeTab(propertyTypeFilter)}</div>
            <div className="swiper-pagination scroll-pagi k-property-pagi-1"></div>
          </div>
          <div title="Next" className="slick-bt-next swiper-button-next next-btn k-next-1"></div>
          <div
            title="Previous"
            className="slick-bt-back swiper-button-prev prev-btn k-prev-1"
          ></div>
        </div>
        <div id="assets-type-tabs2" className="tab-pane fade" role="tabpanel">
          <div className="swiper k-property-swiper-2">
            <div className="swiper-wrapper">{provinceTab(provinceFilter)}</div>
            <div className="swiper-pagination scroll-pagi k-property-pagi-2"></div>
          </div>
          <div title="Next" className="slick-bt-next swiper-button-next next-btn k-next-2"></div>
          <div
            title="Previous"
            className="slick-bt-back swiper-button-prev prev-btn k-prev-2"
          ></div>
        </div>
        <div id="assets-type-tabs3" className="tab-pane fade" role="tabpanel">
          <div className="swiper k-property-swiper-3">
            <div className="swiper-wrapper">{priceTab(priceFilter)}</div>
            <div className="swiper-pagination scroll-pagi k-property-pagi-3"></div>
          </div>
          <div title="Next" className="slick-bt-next swiper-button-next next-btn k-next-3"></div>
          <div
            title="Previous"
            className="slick-bt-back swiper-button-prev prev-btn k-prev-3"
          ></div>
        </div>
      </div>
    </div>
  );
};

export const PopUpSearch = React.memo((props) => {
  //Popup Addanve search
  const searchFilter = props;
  const OnInputChange = props.OnInputChange;
  const searchDataChange = props.searchDataChange;
  const IonRangeDataChange = props.IonRangeDataChange;
  const RangeInputDataChange = props.RangeInputDataChange;
  const OnRadioCheck = props.OnRadioCheck;
  const GoToSearch = props.GoToSearch;
  const ClearSearch = props.ClearSearch;

  const [rangeMin, setRangeMin] = useState("");
  const [rangeMax, setRangeMax] = useState("");
  const [areaMin, setAreaMin] = useState("");
  const [areaMax, setAreaMax] = useState("");
  const [useableAreaMin, setUseableAreaMin] = useState("");
  const [useableAreaMax, setUseableAreaMax] = useState("");

//   const [bedroom, setBedroom] = useState("");
//   const [bathroom, setBathroom] = useState("");

  const handleRadioChange = (type, value) => {
    if (type === "bedroom") {
    //   setBedroom(value);
      OnInputChange("bedroom", value)
    } else if (type === "bathroom") {
    //   setBathroom(value);
      OnInputChange("bathroom", value)
    }
    // Call any other function or logic you want here
  };

  const minMaxString = (min, max) => {
    console.log(min, max);
    if (!min && !max) {
      return "";
    } else if (!min) {
      return `0,${max}`;
    } else if (!max) {
      return min;
    } else {
      return `${min},${max}`;
    }
  };

  const onRangeChange = (field, value) => {
    if (field == "min") {
      setRangeMin(value);
      OnInputChange("rangeField", minMaxString(value, rangeMax));
    } else {
      setRangeMax(value);
      OnInputChange("rangeField", minMaxString(rangeMin, value));
    }
  };

  const onAreaChange = (field, value) => {
    if (field == "min") {
      setAreaMin(value);
      OnInputChange("areaField", minMaxString(value, areaMax));
    } else {
      setAreaMax(value);
      OnInputChange("areaField", minMaxString(areaMin, value));
    }
  };

  const onUseableAreaChange = (field, value) => {
    if (field == "min") {
      setUseableAreaMin(value);
      OnInputChange("useableAreaField", minMaxString(value, useableAreaMax));
    } else {
      setUseableAreaMax(value);
      OnInputChange("useableAreaField", minMaxString(useableAreaMin, value));
    }
  };

  const handleClearSearch = () => {
    setRangeMin("");
    setRangeMax("");
    setAreaMin("");
    setAreaMax("");
    setUseableAreaMin("");
    setUseableAreaMax("");
    ClearSearch();
  };

  const renderCheckBox = (item, index) => {
    if (item[0] !== "fieldName" && item[0] !== "value") {
      const fieldName = item[0];
      const data = item[1];
      // console.log('item', fieldName, data,item[1]);
      // console.log("property-type-m" + index)
      return (
        <div className="swiper-slide" key={"property-type-m" + index}>
          <div className="asset-radio">
            <CheckBoxIonInput {...data} OnformsDataChange={OnRadioCheck} />
          </div>
        </div>
      );
    }
  };

  const renderAssetTypesCheckBox = (item, index) => {
    if (item[0] !== "fieldName" && item[0] !== "value") {
      const fieldName = item[0];
      const data = item[1];
      // console.log('item', fieldName, data,item[1]);
      // console.log("asset-type-m" + index)
      return (
        <div className="checkbox-card" key={"search-property-type" + index}>
          <CheckBoxCustomInput {...data} OnformsDataChange={OnRadioCheck} />
        </div>
      );
    }
  };

  return (
    <>
      <div className="popup-search">
        <div className="container-popup">
          <div className="g-modal-header">
            <h2>ค้นหาอย่างละเอียด</h2>
            <button type="button" className="close-gallery-modal">
              <i className="ic-npa ic-npa-icon-plus" />
            </button>
          </div>
          <div className="option-search-wrapper">
            <div className="option-search">
              <div>
                <div className="popup-row">
                  <input
                    type="text"
                    className="normal-input"
                    placeholder="ชื่อทรัพย์"
                    value={searchFilter.keyword.value}
                    onChange={(e) => OnInputChange("keyword", e.target.value)}
                    onKeyPress={(e) => e.key === "Enter" && GoToSearch()}
                  />
                  <i className="ic-npa ic-npa-icon-search" />
                </div>
                <div className="checkbox-card-wrapper">
                  {Object.entries(searchFilter.assetTypes).map((item, index) =>
                    renderAssetTypesCheckBox(item, index)
                  )}
                </div>
                <div className="popup-row-content">
                  <h3 className="mb-3">ทำเลที่ตั้ง</h3>
                  <SelectList
                    id="province-pop"
                    {...searchFilter.province}
                    OnformsDataChange={searchDataChange}
                  />
                  <SelectList
                    id="district-pop"
                    {...searchFilter.district}
                    OnformsDataChange={searchDataChange}
                  />
                  <SelectList
                    id="sub-district-pop"
                    {...searchFilter.subDistrict}
                    OnformsDataChange={searchDataChange}
                  />
                </div>
                <div className="popup-row-content">
                  <h3 className="mb-3">ประเภททรัพย์</h3>
                  <div className="property-type-swiper">
                    <div className="d-flex flex-wrap">
                      {Object.entries(searchFilter.propertyType).map((item, index) =>
                        renderCheckBox(item, index)
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="popup-row-content">
                  <h3 className="mb-3">ช่วงราคา</h3>
                  <div className="popup-row">
                    <input
                      type="text"
                      className="normal-input"
                      placeholder="ขั้นต่ำ"
                      value={rangeMin}
                      onChange={(e) => onRangeChange("min", e.target.value)}
                    />
                    <span>-</span>
                    <input
                      type="text"
                      className="normal-input"
                      placeholder="สูงสุด"
                      value={rangeMax}
                      onChange={(e) => onRangeChange("max", e.target.value)}
                    />
                  </div>
                </div>
                <div className="popup-row-content">
                  <h3 className="mb-3">เนื้อที่</h3>
                  <div className="popup-row">
                    <input
                      type="text"
                      className="normal-input"
                      placeholder="ขั้นต่ำ (ตร.ว.)"
                      value={areaMin}
                      onChange={(e) => onAreaChange("min", e.target.value)}
                    />
                    <span>-</span>
                    <input
                      type="text"
                      className="normal-input"
                      placeholder="สูงสุด (ตร.ว.)"
                      value={areaMax}
                      onChange={(e) => onAreaChange("max", e.target.value)}
                    />
                  </div>
                </div>
                <div className="popup-row-content">
                  <h3 className="mb-3">พื้นที่ใช้สอย</h3>
                  <div className="popup-row">
                    <input
                      type="text"
                      className="normal-input"
                      placeholder="ขั้นต่ำ (ตร.ม.)"
                      value={useableAreaMin}
                      onChange={(e) => onUseableAreaChange("min", e.target.value)}
                    />
                    <span>-</span>
                    <input
                      type="text"
                      className="normal-input"
                      placeholder="สูงสุด (ตร.ม.)"
                      value={useableAreaMax}
                      onChange={(e) => onUseableAreaChange("max", e.target.value)}
                    />
                  </div>
                </div>
                <div className="popup-row-content">
                  <h3 className="mb-3">ห้องนอน</h3>
                  <div className="popup-row gap">
                    <div className="input-radio">
                      <input
                        type="radio"
                        name="search-bedroom"
                        onChange={(e) => handleRadioChange("bedroom", "1")}
                        checked={searchFilter.bedroom.value === "1"}
                      />
                      <label>1</label>
                    </div>
                    <div className="input-radio">
                      <input
                        type="radio"
                        name="search-bedroom"
                        onChange={(e) => handleRadioChange("bedroom", "2")}
                        checked={searchFilter.bedroom.value === "2"}
                      />
                      <label>2</label>
                    </div>
                    <div className="input-radio">
                      <input
                        type="radio"
                        name="search-bedroom"
                        onChange={(e) => handleRadioChange("bedroom", "3")}
                        checked={searchFilter.bedroom.value === "3"}
                      />
                      <label>3</label>
                    </div>
                    <div className="input-radio">
                      <input
                        type="radio"
                        name="search-bedroom"
                        onChange={(e) => handleRadioChange("bedroom", "4")}
                        checked={searchFilter.bedroom.value === "4"}
                      />
                      <label>4</label>
                    </div>
                    <div className="input-radio">
                      <input
                        type="radio"
                        name="search-bedroom"
                        onChange={(e) => handleRadioChange("bedroom", "5")}
                        checked={searchFilter.bedroom.value === "5"}
                      />
                      <label>5+</label>
                    </div>
                    <div className="input-radio big">
                      <input
                        type="radio"
                        name="search-bedroom"
                        onChange={(e) => handleRadioChange("bedroom", "")}
                        checked={searchFilter.bedroom.value === ""}
                      />
                      <label>ไม่ระบุ</label>
                    </div>
                  </div>
                </div>

                <div className="popup-row-content">
                  <h3 className="mb-3">ห้องน้ำ</h3>
                  <div className="popup-row gap">
                    <div className="input-radio">
                      <input
                        type="radio"
                        name="search-bathroom"
                        onChange={(e) => handleRadioChange("bathroom", "1")}
                        checked={searchFilter.bathroom.value === "1"}
                      />
                      <label>1</label>
                    </div>
                    <div className="input-radio">
                      <input
                        type="radio"
                        name="search-bathroom"
                        onChange={(e) => handleRadioChange("bathroom", "2")}
                        checked={searchFilter.bathroom.value === "2"}
                      />
                      <label>2</label>
                    </div>
                    <div className="input-radio">
                      <input
                        type="radio"
                        name="search-bathroom"
                        onChange={(e) => handleRadioChange("bathroom", "3")}
                        checked={searchFilter.bathroom.value === "3"}
                      />
                      <label>3</label>
                    </div>
                    <div className="input-radio">
                      <input
                        type="radio"
                        name="search-bathroom"
                        onChange={(e) => handleRadioChange("bathroom", "4")}
                        checked={searchFilter.bathroom.value === "4"}
                      />
                      <label>4</label>
                    </div>
                    <div className="input-radio">
                      <input
                        type="radio"
                        name="search-bathroom"
                        onChange={(e) => handleRadioChange("bathroom", "5")}
                        checked={searchFilter.bathroom.value === "5"}
                      />
                      <label>5+</label>
                    </div>
                    <div className="input-radio big">
                      <input
                        type="radio"
                        name="search-bathroom"
                        onChange={(e) => handleRadioChange("bathroom", "")}
                        checked={searchFilter.bathroom.value === ""}
                      />
                      <label>ไม่ระบุ</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="popup-btn">
              <a href={void 0} className="btn-search" onClick={GoToSearch}>
                ค้นหาทรัพย์
              </a>
              <a href={void 0} className="btn-reset-search" onClick={ClearSearch}>
                <i className="ic-npa ic-npa-icon-refresh" />
                <span>ล้างการค้นหา</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}, areEqual);
